// Cheques cache hook — fetches user cheques + refreshes on app data-changed events.
import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";

export function useCheques() {
  const [state, setState] = useState({ items: [], upcoming: [], loading: true });

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/cheques");
      setState({ items: data.items || [], upcoming: data.upcoming || [], loading: false });
    } catch {
      setState({ items: [], upcoming: [], loading: false });
    }
  }, []);

  useEffect(() => {
    load();
    const on = (e) => { if (/cheques/.test(e?.detail?.url || "")) load(); };
    window.addEventListener("malat:data-changed", on);
    return () => window.removeEventListener("malat:data-changed", on);
  }, [load]);

  return { ...state, reload: load };
}
